<template>
    <transition name="slide-fade">
    <s-form-group :id="id" v-if="schema.config[fieldName].show">
            <s-form-checkbox v-model="schema.fields[fieldName]"
                             :id="schema.config[fieldName].id"
                             :name="fieldName"
                             :aria-required="schema.config[fieldName].validation.required"
                             value="Yes">{{$t('message.fields.'+fieldName+'.label') + schema.config[fieldName].domElements.requiredIndicator}}<slot></slot></s-form-checkbox>
    </s-form-group>
    </transition>
</template>

<script>

    import formHelpers from '../../utils/helpers/formHelpers'
    import sFormCheckbox from '../form/s-form-checkbox'
    import sFormGroup from '../form/s-form-group'

    export default {
        name: 'sCheckboxGroup',
        mixins: [formHelpers],
        props:{
            fieldName: String
        },
        data() {
          return {
              schema: this.$root.$data.schema,
              id: 'py-formGroup-'+this.fieldName
          }
        },
        inject: {
            $validator: '$validator'
        },
        components: {
            sFormCheckbox,
            sFormGroup
        },
        methods:{
            change(e){
                this.$parent.$emit("pyInputChange", e.target)
            }
        },
        mounted(){
            this.addEventListeners();
            this.$el.addEventListener("change", this.change)
        }
    }

</script>

